import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less';
// import styles from './rem.less'; //2560
import CookieTipsStore from '@src/business-components/cookie-tips/store';
import Link from '@src/components/link';
import CookieSettingModal from './components/cookie-setting-modal';
import cookieLocalesData from '@src/business-components/cookie-tips/cookie.json';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { PROTOCOL } from '@src/business-components/cookie-tips/cookie.js';
const lang = getLanguageByPath();
const cookieInfo = cookieLocalesData[lang]?.cookieInfo;

/**
 * CookieTips
 * @param store {CookieTipsStore}
 * @param onClose
 * @returns {JSX.Element}
 * @constructor
 */
const CookieTips = ({ store, onClose }) => {
  store.use();
  // if (!store.showModalStatus) {
  //   return null;
  // }
  const renderBtnGroup = () => {
    return (
      <div className={styles.btnGroup}>
        <Link className={cx(styles.cookieSettingsBtn, styles.bigSizeBtn)} onClick={store.onCookieSettingShowClick}>
          {cookieInfo.cookie_setting_btn}
        </Link>
        <div className={styles.bottomBtnPart}>
          <Link className={cx(styles.rejectCookiesBtn, styles.smallSizeBtn)} onClick={store.rejectOptionalCookies}>
            {cookieInfo.reject_all_cookies}
          </Link>
          <Link className={cx(styles.acceptCookiesBtn, styles.smallSizeBtn)} onClick={store.acceptOptionalCookies}>
            {cookieInfo.allow_all_cookies}
          </Link>
        </div>
      </div>
    );
  };
  /**
   * 渲染设置cookie目的文案
   * @returns {JSX.Element}
   */
  const renderContent = () => {
    const cookieLink = PROTOCOL[lang]?.cookie;
    const description = cookieInfo?.cookie_description || '';
    const descriptionWithLink = description.replace('{link}', cookieLink);
    return (
      <div className={styles.content}>
        <span dangerouslySetInnerHTML={{ __html: descriptionWithLink }} />
      </div>
    );
  };
  return (
    <div className={cx('root', store.showModalStatus ? styles.root : styles.hide)}>
      <CookieSettingModal
        store={store.cookieSettingModalStore}
        onClose={() => (store.isDirectToSettingModal ? store.onClose() : store.backToCookieTipModal())}
      />
      {store.showCookieSettings &&
        store.showModalStatus && (
          <div className={styles.container}>
            {renderContent()}
            {renderBtnGroup()}
            <Link className={styles.closeBtn} onClick={store.onClose} />
          </div>
        )}
    </div>
  );
};

export default wrapStore(CookieTips, CookieTipsStore);
